export const TRIATHLON_PATH = 'triathlon';
export const ACTIVITY_YEAR_PATH = 'activities-year';
export const RUNNING_PATH = 'running-semaine';
export const RUNNING_DAY_PATH = 'activities-day';
export const WEEK_PATH = 'week';
export const CALENDAR_PATH = 'calendar';
export const TABLE_PATH = 'table';
export const ZONES_PATH = 'zones';
export const FITNESS_PATH = 'fitness';

export const routesMapper = {
  triathlonPath: 'Triathlon',
  runningPath: 'Running semaine',
  runningDayPath: 'Activités jour',
  weekPath: 'Activités semaine',
  activityYearPath: 'Activités années',
  calendarPath: 'Calendrier',
  tablePath: 'Tableau',
  zonesPath: 'Zones',
  fitnessPath: 'Charge',
};
